// Las Reliquias del conocimiento.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Reliquias del conocimiento ----

export const getCollectiblesCatalog = () =>
  api.get("/collectibles/catalog").then((r) => r.data.items);
export const getMyCollectibles = () =>
  api.get("/collectibles/mine").then((r) => r.data);
export const claimCollectibleSpot = (mapId, spotId) =>
  api.post("/collectibles/claim", { map_id: mapId, spot_id: spotId }).then((r) => r.data);
